import axios from "axios";
import { translations } from "./i18n";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("aqar_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

function translateMsg(msg) {
  const lang = localStorage.getItem("aqar_lang") || "ar";
  if (lang !== "ar") return msg;
  const map = translations.ar.__errors__ || {};
  if (map[msg]) return map[msg];
  // Handle pydantic-like "Value error, X" or "X is not valid" patterns
  const lower = String(msg).toLowerCase();
  if (lower.includes("email")) return map["value is not a valid email address"] || msg;
  if (lower.includes("field required")) return map["Field required"] || msg;
  if (lower.includes("password")) return map["String should have at least 6 characters"] || msg;
  return msg;
}

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return translateMsg(err?.message || "Something went wrong");
  if (typeof detail === "string") return translateMsg(detail);
  if (Array.isArray(detail))
    return detail.map((e) => translateMsg(e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" · ");
  if (detail && typeof detail.msg === "string") return translateMsg(detail.msg);
  return translateMsg(String(detail));
}

export default api;
